import './App.css';
import { Form } from './Form';

function App() {
  return (
    <div className="container">
      <Form />
    </div>
  );
}

export default App;
